
const ArtistStatement = () => {
  return (
    <section id="statement" className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Artist Statement
          </h2>
          <div className="w-24 h-1 bg-teal-600 mx-auto"></div>
        </div>

        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-lg">
          <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed">
            <p className="mb-8 text-xl font-light">
              I'm a photographer who finds inspiration in everyday surroundings. My work blends 
              technical exploration and creative storytelling, whether I'm studying light, capturing 
              portraits, or documenting a passing moment.
            </p>
            
            <p className="mb-8">
              I approach each project with curiosity, allowing ideas to develop naturally through 
              observation and experimentation. My subjects range from people and places to still 
              lifes, and I often include video or animation to expand how a story can be experienced.
            </p>
            
            <p className="mb-0 text-lg font-medium text-gray-900">
              Ultimately, my photography reflects the world around me — thoughtful, honest, and 
              always evolving.
            </p>
          </div>
        </div>

        {/* Philosophy Points */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
          <div className="text-center">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-eye-line text-2xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Vision</h3>
            <p className="text-gray-600">
              Seeing beyond the surface to capture the essence and emotion within each moment
            </p>
          </div>
          
          <div className="text-center">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-palette-line text-2xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Expression</h3>
            <p className="text-gray-600">
              Using light, composition, and timing to create visual narratives that resonate
            </p>
          </div>
          
          <div className="text-center">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-heart-line text-2xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Connection</h3>
            <p className="text-gray-600">
              Creating images that forge emotional bonds between viewer and subject
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ArtistStatement;
